import * as React from 'react';

interface ICommonPopupLayoutProps {
    body: React.ReactNode;
    footer?: React.ReactNode;
    header?: React.ReactNode;
    className?: string;
    classNameBody?: string;
}

/**
 * render full popup layout including optional header/footer and mandatory body.
 * className property stands for custom class assignment to root layout element.
 * @param props
 * @constructor
 */
const CommonPopupLayout = (props: ICommonPopupLayoutProps) => {
    const className = 'oe-popup-layout' + (props.className ? ' ' + props.className : '');
    const classNameBody = 'oe-popup-layout__body' + (props.classNameBody ? ' ' + props.classNameBody : '');
    const content = (
        <>
            {props.header && <div className='oe-popup-layout__header'>
                {props.header}
            </div>}
            <div className={classNameBody}>
                {props.body}
            </div>
            {props.footer && <div className='oe-popup-layout__footer'>
                {props.footer}
            </div>}
        </>
    );

    return (
        <div className={className}>
            {content}
        </div>
    );
};

export { CommonPopupLayout, ICommonPopupLayoutProps };



